import { useEffect, useState } from 'react';
const prefixClasses = (prefix, states) => {
    const prefixClass = (state) => [prefix, state].join('-');
    return Object.entries(states)
        .filter(([, value]) => value)
        .map(([key]) => prefixClass(key));
};
export const useInput = (classPrefix, args) => {
    const { disabled, error, onChange, onFocus, onBlur, onMouseEnter, onMouseLeave, value: incomingValue, } = args;
    const [value, setValue] = useState(incomingValue || '');
    const [focus, setFocus] = useState(false);
    const [hover, setHover] = useState(false);
    useEffect(() => {
        if (!incomingValue)
            return;
        setValue(incomingValue);
    }, [incomingValue]);
    const handleFocus = (state) => {
        return (e) => {
            setFocus(state);
            state ? onFocus && onFocus(e) : onBlur && onBlur(e);
        };
    };
    const handleHover = (state) => {
        return (e) => {
            setHover(state);
            state ? onMouseEnter && onMouseEnter(e) : onMouseLeave && onMouseLeave(e);
        };
    };
    const handleChange = (e) => {
        const target = e.target;
        setValue(target.value);
        onChange && onChange(e);
    };
    const inputClasses = prefixClasses(classPrefix, {
        error: !!error,
        disabled: !!disabled,
        focus: focus && !disabled,
        hover: !disabled && !error && !focus && hover,
    });
    return {
        inputClasses,
        focus,
        setFocus,
        hover,
        setHover,
        value,
        setValue,
        events: {
            onChange: handleChange,
            onFocus: handleFocus(true),
            onBlur: handleFocus(false),
            onMouseEnter: handleHover(true),
            onMouseLeave: handleHover(false),
        },
    };
};
//# sourceMappingURL=useInput.js.map